import { FormGroup, Icons, Select, SelectProps } from '@agro-club/agroclub-shared'
import { CurrencyCode } from 'modules/domain/export/types'
import { FormikFieldsType } from 'modules/domain/types'
import { FC, ReactNode } from 'react'
import styled from 'styled-components'

const WrapperOption = styled.div`
  display: flex;
  align-items: center;
  gap: 0 4px;
`

const CustomOption = ({ option }) => {
  const icon = () => {
    const flagIcons = {
      [CurrencyCode.USD]: <Icons.IconFlagus />,
      [CurrencyCode.EUR]: <Icons.IconFlageu />,
      [CurrencyCode.AED]: <Icons.IconFlaguae />,
      [CurrencyCode.CNY]: <Icons.IconFlagcn />,
      [CurrencyCode.RUB]: <Icons.IconFlagRussia />,
    }

    return flagIcons[option.value]
  }

  return (
    <WrapperOption>
      {icon()}
      <div> {option.label}</div>
    </WrapperOption>
  )
}

const defaultOptions = [
  {
    value: CurrencyCode.USD,
    label: 'USD',
  },
  {
    value: CurrencyCode.EUR,
    label: 'EUR',
  },
  {
    value: CurrencyCode.RUB,
    label: 'RUB',
  },
  {
    value: CurrencyCode.AED,
    label: 'AED',
  },
  {
    value: CurrencyCode.CNY,
    label: 'CNY',
  },
]

type Props = {
  formik: FormikFieldsType
  label?: ReactNode
  field: string
  options?: SelectProps['options']
}

export const FormCurrencySelect: FC<Props> = ({ formik, field, options, label }) => {
  return (
    <FormGroup label={label} error={formik.errors[field]}>
      <Select
        onChange={(val) => formik.setFieldValue(field, val)}
        value={formik.values[field]?.toString()}
        OptionComponent={CustomOption}
        allowClear={false}
        showSearch={false}
        options={options || defaultOptions}
        fullWidth
        status={formik.errors[field] ? 'error' : ''}
      />
    </FormGroup>
  )
}
